import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header-item',
  templateUrl: './header-item.component.html',
  styleUrls: ['./header-item.component.scss'],

  imports: [RouterLink, NgClass]
})
export class HeaderItemComponent {
  @Input() item: MenuItem | null = null;
  @Output() itemSelected = new EventEmitter<MenuItem>();
  constructor() {}

  selected(item: MenuItem): void {
    this.itemSelected.emit(item);
  }
}
